import { Action } from '@ngrx/store';
import { NavigationNode } from '../../models';

export enum NavigationActionTypes {
  Load = '[Navigation] Load',
  LoadSuccess = '[Navigation] Load Success',
}

export class Load implements Action {
  readonly type = NavigationActionTypes.Load;
}

export class LoadSuccess implements Action {
  readonly type = NavigationActionTypes.LoadSuccess;
  constructor(public payload: NavigationNode[]) { }
}

export type NavigationActions= Load | LoadSuccess



// WEBPACK FOOTER //
// ./src/app/core/store/actions/navigation.actions.ts